<template>
  <div>
    <Modal v-model="login" title="请您先登录" width="500px" :styles="{top: '60px'}">
      <Row style="margin-top: 20px;text-align: center">
        <Col >
        <Input type="text" placeholder="请输入登录名："/>
        </Col>
      </Row>
      <Row style="margin-top: 20px;text-align: center">
        <Col>
        <Input type="password" placeholder="请输入密码："/>
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col>
        <Button type="primary" @click="sumbit()">登录</Button>
        </Col>
      </Row>
      <div slot="footer"></div>
    </Modal>
    <div style="margin:50px 20% 100px 20%;border: 0px solid;">
      <div style="margin:30px 10px 30px 100px;text-align: left;float:left;">
        <img src="../../assets/commodity/02/00.jpg" style="width: 300px;height: 300px;">
      </div>
      <div style="margin: 20px 10px 20px 10px;text-align: center;">
        <span style="font-size: 20px">腹肌贴</span>
        <p style="margin-top: 20px;">
          <span style="font-size: 15px;">卖家：</span>
          <a @click="login = true" style="font-size: 15px">厦门伴玩</a>
        </p>
        <p style="margin-top: 20px;">
          <span style="font-size: 15px;">原价：</span>
          <span style="font-size: 15px;text-decoration:line-through;">￥499</span>
        </p>
        <p style="margin-top: 20px;">
          <span style="font-size: 15px;">现价：</span>
          <span style="font-size: 25px;color: red">￥418</span>
        </p>
<!--        <p style="margin-top: 20px;">-->
<!--          <span style="font-size: 15px;">尺码：</span>-->
<!--          <Select style="width: 180px">-->
<!--            <Option  label="37"></Option >-->
<!--            <Option  label="38"></Option >-->
<!--            <Option  label="39"></Option >-->
<!--            <Option  label="40"></Option >-->
<!--            <Option  label="41"></Option >-->
<!--            <Option  label="42"></Option >-->
<!--            <Option  label="43"></Option >-->
<!--            <Option  label="44"></Option >-->
<!--          </Select>-->
<!--        </p>-->
        <p style="margin-top: 20px;">
          <span style="font-size: 15px;">颜色分类：</span>
          <Select style="width: 180px">
<!--            <Option  label="白色"></Option >-->
            <Option  label="黑色"></Option >
            <Option  label="橙色"></Option >
<!--            <Option  label="渐茶色"></Option >-->
          </Select>
        </p>
        <p style="margin-top: 20px;">
          <span style="font-size: 15px;">数量：</span>
          <InputNumber :max="999" :min="1" ></InputNumber>
        </p>
        <p style="margin-top: 20px;">
          <Button type="warning" style="width: 200px;height: 60px;font-size: 30px;">立即购买</Button>
          <Button type="error" style="width: 200px;height: 60px;font-size: 30px;">加入购物车</Button>
        </p>
      </div>
    </div>
    <div style="margin-top:50px;margin-bottom:100px;text-align: center">
      <span style="font-size: 20px;margin-top: 50px">商品详情</span>
      <h5><img src="../../assets/blue.png"></h5>
      <div style="margin-left:50px;width:280px;margin-left:300px;text-align:left;border: 0px solid;float:left;text-align: left;height: 1500px">
        <img src="../../assets/zy.png"/>
        <p style="font-size: 20px;margin-top: 20px;"><span>店主：厦门伴玩</span></p>
        <p style="font-size: 20px;margin-top: 20px;"><span>联系：188****9330</span></p>
        <p style="font-size: 20px;margin-top: 20px;"><span>地址：福建省厦门市湖里区...</span></p>
        <div style="font-size: 20px;margin-top: 20px;">
          <Button type="primary" icon="md-home">进入店铺</Button>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <Button type="error" icon="md-heart">关注店铺</Button>
        </div>
      </div>
      <div style="text-align: center;border: 0px solid;text-align: left">
      <img src="../../assets/commodity/02/01.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>
      <img src="../../assets/commodity/02/02.jpg" width="800px" height="1200px;" style="margin-top: 10px;"/>
<!--      <img src="../../assets/commodity/02/03.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/04.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/05.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/06.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/07.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/08.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/09.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/10.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/11.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/12.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/13.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/14.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/15.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/16.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/17.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
<!--      <img src="../../assets/commodity/02/18.jpg" width="800px" height="900px;" style="margin-top: 10px;"/>-->
    </div>
      </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        login:false,
      }
    },
    mounted () {

    },
    methods:{

    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a:link{
    color:black;
  }
  a:hover{
    color:red;
  }
  a:active{
    color:darkred;
  }
  .image-into{
    padding:10px;
  }
  .image-out{
    padding:0px;
  }
  .demo-split{
    height: 200px;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
  .demo-split-pane.no-padding{
    height: 200px;
    padding: 0;
  }

  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
  .govm-ico {
    display: inline-block;
    width: 18px;
    height: 20px;
    /*background: url("../../assets/images/home_pic.png") no-repeat -87px -31px;*/
    position: relative;
    top: 4px;
    right: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/commodity/Commodity02.vue